import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { ClinPageContentFrame } from '../../components/ClinPageContentFrame'
import { ClinText } from '../../components/ClinText'
import { mediaQueryDown } from '../../utils/mediaQuery'
import { ClinButton } from '../../components/ClinButton'
import { ClinGroup } from '../../components/ClinGroup'

const desktopUpBreakpoint = ClinTheme.breakpoints[2]

export const StyledPreferencesHeaderContainer = styled.div({
  maxWidth: '100%',
  margin: '0 auto',
  backgroundColor: ClinTheme.colors.white
})

export const StyledHeaderClinPageContentFrame = styled(ClinPageContentFrame)({
  padding: '24px 0',
  marginBottom: '24px !important',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    padding: '16px 0'
  }
})

export const StyledFormClinPageContentFrame = styled(ClinPageContentFrame)({
  backgroundColor: ClinTheme.colors.white,
  padding: '24px',
  borderRadius: '4px',
  boxSizing: 'border-box',
  display: 'flex',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    display: 'block',
    marginLeft: '16px !important',
    marginRight: '16px !important'
  }
})

export const StyledPreferencesHeaderTitle = styled(ClinText)({
  fontFamily: ClinTheme.fonts.groteskExtraBold,
  fontWeight: ClinTheme.fontWeights.bolder,
  color: ClinTheme.colors.black,
  margin: 0,

  [mediaQueryDown(desktopUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[4],
    marginLeft: ClinTheme.space[2]
  }
})

export const StyledLanguageContainer = styled.div({
  borderRight: '1px solid ' + ClinTheme.colors.midGrey,
  maxWidth: '360px',
  width: '100%',
  padding: '0 24px 0 8px',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    maxWidth: '100%',
    borderRight: 0,
    padding: 0,
    boxSizing: 'border-box',
    marginBottom: ClinTheme.space[7]
  }
})

export const StyledMarketingContainer = styled.div({
  width: '100%',
  padding: '0 8px 0 24px',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    padding: 0,
    boxSizing: 'border-box'
  }
})

export const StyledClinButton = styled(ClinButton)({
  fontSize: ClinTheme.fontSizes[2],

  [mediaQueryDown(desktopUpBreakpoint)]: {
    width: '100%',

    ':nth-child(n)': {
      margin: 0
    },

    ':first-child': {
      margin: '0 0 16px'
    }
  }
})

export const StyledClinGroup = styled(ClinGroup)({
  [mediaQueryDown(desktopUpBreakpoint)]: {
    display: 'block'
  }
})

export const StyledClinButtonMobile = styled(ClinButton)({
  width: ClinTheme.space[7],
  justifyContent: 'center',
  display: 'none',
  [mediaQueryDown(desktopUpBreakpoint)]: {
    display: 'inline-flex'
  }
})

export const StyledInviteHeaderNavigation = styled.div({
  display: 'flex',
  alignItems: 'center',
  [mediaQueryDown(desktopUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[4]
  }
})
